import { CartAddEvent } from '@theme/events';

/**
 * <complete-the-set>
 *
 * Adds every item in a fixed-price bundle to the cart in a single request.
 * The bundle price shown in the UI is enforced by a Shopify discount, not here.
 */
class CompleteTheSet extends HTMLElement {
  connectedCallback() {
    this.variantIds = (this.dataset.bundleVariants || '')
      .split(',')
      .map((v) => Number(v.trim()))
      .filter((v) => v > 0);

    this.addButton = this.querySelector('[data-bundle-add]');
    this.buttonLabel = this.querySelector('[data-bundle-button-label]');
    this.addButton?.addEventListener('click', this.#addBundle);
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.#addBundle);
  }

  #cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  #addBundle = async () => {
    if (!this.variantIds.length || !this.addButton) return;

    const items = this.variantIds.map((id) => ({ id, quantity: 1 }));
    const sections = this.#cartSectionIds();
    const originalLabel = this.buttonLabel?.textContent;

    this.addButton.disabled = true;
    if (this.buttonLabel) this.buttonLabel.textContent = 'Adding…';

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sections.join(',') }),
      });
      const data = await response.json();

      if (data.status) {
        if (this.buttonLabel) this.buttonLabel.textContent = data.description || 'Could not add bundle';
        setTimeout(() => {
          if (this.buttonLabel) this.buttonLabel.textContent = originalLabel;
          this.addButton.disabled = false;
        }, 3000);
        return;
      }

      this.dispatchEvent(
        new CartAddEvent({}, this.id || 'bundle', {
          source: 'bundle',
          itemCount: items.length,
          sections: data.sections,
        })
      );

      if (this.buttonLabel) this.buttonLabel.textContent = originalLabel;
      this.addButton.disabled = false;
    } catch (error) {
      console.error('[bundle] add failed', error);
      if (this.buttonLabel) this.buttonLabel.textContent = originalLabel;
      this.addButton.disabled = false;
    }
  };
}

if (!customElements.get('complete-the-set')) {
  customElements.define('complete-the-set', CompleteTheSet);
}
